import NFTinterface from "../interface/NFTinterface";
import deployerInterface from "../interface/deployerInterface";
import web3 from "../web3";

export const buy = async (_amount, _tokenId, _tokenAddress, _value) => {
  try {
    let instance = await NFTinterface(_tokenAddress);

    let value = _value;

    let result = await instance.methods
      .mint(_amount, _tokenId)
      .send({ from: window.ethereum.selectedAddress, value });

    return result;
  } catch (error) {
    console.log(error);
  }
};

export const bid = async (_tokenId, _tokenEdition, _tokenAddress, _value) => {
  try {
    let instance = await NFTinterface(_tokenAddress);

    let value = web3.utils.toWei(_value.toString());

    let result = await instance.methods
      .bid(_tokenId, _tokenEdition)
      .send({ from: window.ethereum.selectedAddress, value });

    return result;
  } catch (error) {
    console.log(error);
  }
};

export const deployCollection = async (_uris, _prices, _amounts, _auction) => {
  try {
    let instance = await deployerInterface();
    let prices = [];
    _prices.map((el) => {
      prices.push(web3.utils.toWei(el));
    });
    console.log({ _uris, prices, _amounts, _auction });
    let result = await instance.methods
      .createToken(_uris, prices, _amounts, _auction)
      .send({ from: window.ethereum.selectedAddress });

    return result;
  } catch (error) {
    console.log(error);
  }
};

export const getCollectionItems = async (_address) => {
  try {
    let instance = await NFTinterface(_address);

    let items = await instance.methods.collectionItems().call();
    let itemsData = [];

    for (let i = 0; i < items; i++) {
      let data = await instance.methods.tokenIdtoData(i).call();
      itemsData.push(data);
    }

    return itemsData;
  } catch (error) {
    console.log(error);
  }
};

export const getItemData = async (_tokenId, _tokenAddress) => {
  try {
    let instance = await NFTinterface(_tokenAddress);
    let step = await instance.methods.auctionStep().call();
    let data = await instance.methods.tokenIdtoData(_tokenId).call();
    let isAuction = data.isAuction;
    let supply = Number(data.maxSupply);
    let currentSupply = Number(data.currentSupply);
    let price = data.price;

    let bids = [];
    let highBid = 0;
    let smallBid = 0;
    let indexSmall = 0;
    if (isAuction) {
      for (let i = 0; i < supply; i++) {
        let bid = await instance.methods
          .tokenId_edition_bid(_tokenId, i)
          .call();
        if (highBid === 0) {
          highBid = bid;
          smallBid = bid;
          indexSmall = i;
        } else if (Number(bid) > Number(highBid)) {
          highBid = bid;
        } else if (Number(bid) < Number(smallBid)) {
          smallBid = bid;
          indexSmall = i;
        }
        bids.push(bid);
      }
    }

    return {
      isAuction,
      supply,
      currentSupply,
      price,
      bids,
      highBid,
      step,
      smallBid,
      indexSmall,
    };
  } catch (error) {
    console.log(error);
  }
};
